export const shallowEqual = <T extends Record<keyof T, unknown>>(a: T, b: T) =>
  (Object.keys(a) as (keyof T)[]).every((key) => a[key] === b[key]);
